// Small farm effects drawn in the farm's world container, shared by the visitor's help and the farm activity of
// other players (farmFx): a splash on a watered crop (the drawn drop until its picture lands).

// A water drop over a crop — popped in once, held a moment, faded out (owner 2026-09-30: a plain dot didn't read, and it
// should disappear after a while).
// A teardrop (round bottom, point on top) drawn into `g` around its origin, `k` times its 16 px — the
// watering mark over a crop, and the Konewka's icon on its tile and Rynek card (there is no water icon).
export function drawDrop(g, k = 1) {
  const pts = [];
  for (let a = 0; a <= Math.PI; a += Math.PI / 12) pts.push({ x: Math.cos(a) * 8 * k, y: Math.sin(a) * 8 * k });
  pts.unshift({ x: 0, y: -14 * k });
  g.fillStyle(0x2a4a7a, 1).fillPoints(pts.map((p) => ({ x: p.x * 1.25, y: p.y * 1.2 + k })), true);   // dark outline
  g.fillStyle(0x4aa3ff, 1).fillPoints(pts, true);
  g.fillStyle(0xffffff, 0.85).fillEllipse(-3 * k, k, 3.5 * k, 5 * k);                                   // the shine
  return g;
}

// The splash picture (farm_fx_splash, 2026-10-27): bursts up out of the crop, holds, fades — about a second
// (owner: smaller and shorter).
const SPLASH = 'farm_fx_splash', SPLASH_W = 40;

export function waterDrop(scene, cx, cy) {
  if (scene.textures.exists(SPLASH)) {
    const src = scene.textures.get(SPLASH).getSourceImage();
    const s = SPLASH_W / src.width;
    const img = scene.add.image(cx, cy - 6, SPLASH).setOrigin(0.5, 0.85).setDepth(cy + 40).setName('helpDrop');
    scene.world.objects.add(img);
    img.setScale(s * 0.3, s * 0.15).setAlpha(0);
    scene.tweens.chain({ targets: img, tweens: [
      { scaleX: s, scaleY: s, alpha: 1, duration: 180, ease: 'Back.Out' },
      { scaleY: s * 0.94, duration: 450, ease: 'Sine.InOut' },
      { alpha: 0, scaleX: s * 1.1, duration: 300, onComplete: () => img.destroy() },
    ] });
    return;
  }
  const g = drawDrop(scene.add.graphics().setPosition(cx + 16, cy - 34).setDepth(cy + 40).setName('helpDrop'));
  scene.world.objects.add(g);
  g.setScale(0.2).setAlpha(0);
  scene.tweens.chain({ targets: g, tweens: [
    { scale: 1, alpha: 1, duration: 220, ease: 'Back.Out' },
    { y: g.y - 6, duration: 2300, ease: 'Sine.InOut' },
    { alpha: 0, duration: 700, onComplete: () => g.destroy() },
  ] });
}
